import React from 'react';
import '../css/imprimir.css';
import background from '../assets/backgroundImprimir.svg';
import logo from '../assets/logoNegro.png';


function PaginaImprimir(props) {
    return (
        <>
            {props.eventoActual !== undefined &&
                <div className='position-relative paginaImprimir'>
                    <div className='container containerImprimir '>
                        <div className='row align-items-center nombreEvento'>
                            <div className='col-8 '>
                                <div className='fw-bolder'>{props.esEmpresas || props.esTodas || props.esParaEmpresas ? props.eventoActual.nombre.toUpperCase() : props.eventoActual.nombreEvento.toUpperCase()}</div>
                                <div className='ms-1 fw-semibold'>{props.esEmpresas || props.esTodas || props.esParaEmpresas? props.eventoActual.fecha : props.eventoActual.fechaEvento}</div>
                            </div>
                            <div className='col text-end'>
                                <img className=' logoUnionImprimir' src={logo} alt="" />
                            </div>
                        </div>
                        <div className='tablaImprimir'>
                            {props.esEmpresas ? (
                                <>
                                    <div className='fw-bold nombreEmpresaImprimir'>Empresas inscriptas</div>

                                    <div className='row text-center fw-bold encabezadosImprimir rowImprimir'>
                                        <div className='col'>Empresa</div>
                                    </div>
                                    <div id="reuniones1" className='reuniones fw-medium '>
                                        {props.reuniones.length !== 0 ?
                                            props.reuniones.map(function (elem) {
                                                return (

                                                    <div className='row text-center rowImprimir borderRowImprimir'>
                                                        <div className='col'>
                                                            {elem.nombre}
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            :
                                            <></>
                                        }
                                    </div>
                                </>
                            ) : props.esTodas ? (
                                <>
                                    <div className='fw-bold nombreEmpresaImprimir'>Reuniones</div>
                                    <div className='row text-center fw-bold encabezadosImprimir rowImprimir'>
                                        <div className='col-2'>Horario</div>
                                        <div className='col'>Empresas</div>
                                        <div className='col-2'>Mesa</div>

                                    </div>
                                    <div id="reuniones1" className='reuniones fw-medium '>
                                        {props.reuniones.length !== 0 ?
                                            props.reuniones.map(function (elem, i) {
                                                return (

                                                    <div className='row text-center rowImprimir borderRowImprimir'>
                                                        <div className='col-2'>
                                                            {elem.horaInicio}
                                                        </div>
                                                        <div className='col'>
                                                            {`${elem.empresas[0].nombre} - ${elem.empresas[1].nombre}`}
                                                        </div>
                                                        <div className='col-2'>
                                                            {elem.mesa}
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            :
                                            <></>
                                        }
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className='fw-bold nombreEmpresaImprimir'>{props.esParaEmpresas ? props.nombreEmpresa : localStorage.getItem(process.env.REACT_APP_NOMBRE_EMPRESA)}</div>
                                    <div className='row text-center fw-bold encabezadosImprimir rowImprimir'>
                                        <div className='col-2'>Horario</div>
                                        <div className='col'>Empresa</div>
                                        <div className='col-2'>Mesa</div>

                                    </div>
                                    <div id="reuniones1" className='reuniones fw-medium '>
                                        {props.reuniones.length !== 0 ?
                                            props.reuniones.map(function (elem, i) {
                                                return (

                                                    <div className='row text-center rowImprimir borderRowImprimir'>
                                                        <div className='col-2'>
                                                            {elem.horaInicio}
                                                        </div>
                                                        <div className='col'>
                                                            {elem.empresa.nombre}
                                                        </div>
                                                        <div className='col-2'>
                                                            {elem.numeroMesa}
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            :
                                            <></>
                                        }
                                    </div>
                                </>
                            )
                            }

                        </div>
                    </div>
                    <img className='position-absolute  start-0 end-0 w-100 z--1 imagenBackImprimir' src={background} alt="" />
                </div>

            }
        </>
    );
}


export default PaginaImprimir;